<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              条码朔源
              <span style="font-size: 12px; color: #999999;">可输入条码和mcu查询</span>
            </h3>
          </div>
          <div class="box-body no-padding">
            <div style="padding-top: 20px;display: flex;justify-content: center;">
              <el-form :inline="true">
                <el-form-item>
                  <el-select
                      size="medium"
                      style="width: 400px;"
                      v-model="query.bar_code"
                      filterable
                      remote
                      clearable
                      reserve-keyword
                      placeholder="请输入条码或MCU查询"
                      :remote-method="loadSelect"
                      :loading="selectIng"
                  >
                    <el-option
                        v-for="(item, i) in selectList"
                        :key="i"
                        :label="item.bar_code + '【' + item.name + '】'"
                        :value="item.bar_code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button size="medium" type="primary" :disabled="listLoading" @click="querySelect">查询</el-button>
                </el-form-item>
              </el-form>
            </div>

            <el-card v-loading="listLoading">
              <div style="padding: 20px;" v-if="detail.bar_code">
                <h2>产品信息</h2>
                <el-descriptions :column="3" border>
                  <el-descriptions-item label="条码信息">
                    {{ detail.bar_code }}
                  </el-descriptions-item>
                  <el-descriptions-item label="MCU">
                    {{ detail.mcu }}
                  </el-descriptions-item>
                  <el-descriptions-item label="产品名称">
                    {{ detail.name }}
                  </el-descriptions-item>
                  <el-descriptions-item label="存货编码">
                    {{ detail.model_code }}
                  </el-descriptions-item>
                  <el-descriptions-item label="当前状态">
                    {{ detail.status_desc }}
                  </el-descriptions-item>
                </el-descriptions>
              </div>

              <div style="padding: 20px;" v-if="list.length > 0">
                <h2>朔源日志</h2>
                <el-table :data="list" border style="width: 100%">
                  <el-table-column prop="create_time" label="时间"></el-table-column>
                  <el-table-column prop="status_desc" label="状态"></el-table-column>
                  <el-table-column prop="people" label="出库人"></el-table-column>
                </el-table>
              </div>
            </el-card>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import qs from "qs";

export default {
  components: {},
  data() {
    return {
      params: {},
      query: {
        bar_code: '',
      },
      detail: {},
      list: [],
      listLoading: false,
      selectIng: false,
      selectList: [],
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query);
    _this.listLoading = true;
    _this.authInit(_this).then(() => {
      if (_this.query.bar_code) {
        _this.loadDetail();
      } else {
        _this.listLoading = false;
        _this.updateUrl();
      }
      _this.loadSelect('');
    });
  },
  methods: {
    ...mapActions(["authInit"]),
    updateUrl() {
      const _this = this;
      const url = _this.$route.path + "?" + qs.stringify(_this.query);
      _this.$router.replace({path: url});
    },
    // 搜索
    loadSelect(keyword) {
      const _this = this;
      return new Promise((resolve) => {
        _this.selectIng = true;
        _this.$api.traceBarCodeSearch({
          keyword: keyword,
          page: 1,
          size: 50,
        }).then(res => {
          _this.selectIng = false;
          _this.selectList = res.list;
          resolve();
        }).catch(() => {
          _this.selectIng = false;
          resolve();
        })
      })
    },
    // 获取列表
    loadDetail() {
      const _this = this;
      _this.$api.traceDetail(_this.query)
          .then(res => {
            _this.listLoading = false;
            _this.detail = res.detail;
            _this.list = res.log_list;
            _this.updateUrl();
          })
          .catch(err => {
            _this.listLoading = false;
            _this.$message.error(err.msg);
          })
    },
    // 筛选
    querySelect() {
      const _this = this;
      _this.listLoading = true;
      _this.loadDetail();
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>